<div class="table-container">
  <app-scroll-view
    class="scroll-view"
    [vertical]="false"
    [horizontal]="true"
    [appBlockModalDrag]="!isMobileMode"
  >
    <table class="table-results" mat-table [dataSource]="_pagedData">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="table-header-cell"></th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          class="table-cell actions-column"
        >
          <div #btnZoomToEl class="btn-item">
            <app-button
              [buttonType]="isBtnZoomActive(i) ? 'primary' : 'normal'"
              styleType="text"
              sizeType="small"
              shapeType="circle"
              icon="assets/icons/location-arrow.svg"
              (click)="onBtnZoomToClick(i)"
            ></app-button>

            <app-tooltip
              [target]="btnZoomToEl"
              verticalAlignment="top"
              horizontalAlignment="center"
            >
              Ver no mapa
            </app-tooltip>
          </div>
          <div #btnDownloadDocEl class="btn-item">
            <app-button
              buttonType="normal"
              styleType="text"
              sizeType="small"
              shapeType="circle"
              icon="assets/icons/file.svg"
              (click)="onBtnDownloadDocClick(i)"
              [disabled]="!(hasDocumentsObservable(i) | async)"
            ></app-button>

            <app-tooltip
              [target]="btnDownloadDocEl"
              verticalAlignment="top"
              horizontalAlignment="center"
            >
              Download documento
            </app-tooltip>
          </div>
          <div #btnEditEl class="btn-item">
            <app-button
              [buttonType]="isBtnEditActive(i) ? 'primary' : 'normal'"
              styleType="text"
              sizeType="small"
              shapeType="circle"
              icon="assets/icons/pen.svg"
              (click)="onBtnEditClick(i)"
              [disabled]="!(canEditItemObservable(i) | async)"
            ></app-button>

            <app-tooltip
              [target]="btnEditEl"
              verticalAlignment="top"
              horizontalAlignment="center"
            >
              {{ translationService.getCurrentLanguage()?.edit || 'Editar' }}
            </app-tooltip>
          </div>
        </td>
      </ng-container>

      <ng-container
        matColumnDef="{{ field.name }}"
        *ngFor="let field of fields"
      >
        <th mat-header-cell *matHeaderCellDef class="table-header-cell">
          {{ field.alias ?? field.name }}
        </th>
        <td mat-cell *matCellDef="let item" class="table-cell">
          {{ item?.[field.name] | fieldFormat : field : searchResultsService.layers }}
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="table-header"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
      ></tr>
    </table>
  </app-scroll-view>
</div>

<div class="pagination-row">
  <app-pagination
    [totalCount]="resultList?.length ?? 0"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    (pageIndexChange)="onPageIndexChange($event)"
    [appBlockModalDrag]="!isMobileMode"
  >
    <ng-template ngbPaginationText let-totalCount="totalCount">
      Total: {{ totalCount | number }} de
      {{ totalCountObservable | async | number }}
    </ng-template>
  </app-pagination>
</div>
